import axios from 'axios'

let SERVER_BASE_URL = ''

import global_ from "../global/index"
import {
  MessageBox
} from 'element-ui'
import router from '../router';
import {
  Loading
} from 'element-ui';



if (process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'testing') {
  // SERVER_BASE_URL = window.location.hostname;
  SERVER_BASE_URL = '';
} else if (process.env.NODE_ENV == 'development') {
  SERVER_BASE_URL = '/api'
}
console.log('SERVER_BASE_URL::', SERVER_BASE_URL)
export {
  SERVER_BASE_URL
}

let token = null
let loadingInstance = "";
axios.defaults.withCredentials = true;
export default function fetch(options) {
  //token = 'test'
  return new Promise((resolve, reject) => {
    sso.ready().then(user => {
      const instance = axios.create({
        baseURL: SERVER_BASE_URL,
        method: options.method,
        // withCredentials: true,
        // headers: {
        //     'Authorization': token
        // },
        transformResponse: [function (data) {}]
      })
      console.log('SERVER_BASE_URL', SERVER_BASE_URL);
      instance.interceptors.request.use(
        config => {
          // loadingInstance = Loading.service({ fullscreen: true ,text:'加载中',background:'rgba(0,0,0,0.5)'});
          if (options.type == 2) {
            config.headers['Content-Type'] = 'multipart/form-data'
          } else {
            config.headers['Content-Type'] = 'application/json;charset=utf-8'
          }

          return config
        },
        err => {
          return Promise.reject(err)
        })

      instance.interceptors.response.use(
        response => {
          // loadingInstance.close();
          let res = response.request.response
          res = JSON.parse(res)
          return res
        },
        error => {
          if(!error.response || !user.isNotLogin(error.response.status,error.response.headers)){
            console.log('网络不给力，请稍后重试');
            return Promise.reject(error) // 返回接口返回的错误信息
          }
          // loadingInstance.close();
        })

      // 请求处理
      instance(options)
        .then((res) => {
          resolve(res)
          return false
        })
        .catch((error) => {
          reject(error)
        })
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js